var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.923 7.46997C15.923 7.46997 15.3868 14.2099 15.0845 17.0399C15.0666 17.6332 14.8209 18.1952 14.4009 18.6035C13.9808 19.0118 13.4204 19.2334 12.8418 19.22H12.7833C10.2383 19.22 7.69337 19.27 5.14841 19.22C4.58007 19.2389 4.02747 19.0267 3.61104 18.6296C3.1946 18.2325 2.94808 17.6827 2.92523 17.1C2.6132 14.24 2.08667 7.52002 2.08667 7.52002",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2688 4.23999H0.692383",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0803 4.23999C13.7101 4.24035 13.3512 4.10889 13.0649 3.86817C12.7786 3.62745 12.5826 3.2923 12.5104 2.91993L12.2666 1.69996C12.1975 1.42775 12.0423 1.18683 11.8252 1.0149C11.6081 0.842961 11.3416 0.749788 11.0673 0.750004H6.94268C6.66716 0.749282 6.39916 0.842077 6.18045 1.01392C5.96174 1.18576 5.80462 1.42695 5.73359 1.69996L5.48982 2.91993C5.41758 3.2923 5.22159 3.62745 4.93529 3.86817C4.649 4.10889 4.29014 4.24035 3.91992 4.23999",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostDelete);
export default __webpack_public_path__ + "static/media/post_delete.76fedf077dd1fcb78107d45d7760c2ef.svg";
export { ForwardRef as ReactComponent };